import { Card, Skeleton } from '@monksflow/monks-ui';

/**
 * Loading placeholder for a tracker card. Mirrors `TrackerCard`'s shell,
 * padding, and layout 1:1 (cover tile + title + wrapped description + footer) so the
 * swap to loaded content produces zero layout shift.
 */
export const TrackerCardSkeleton = () => (
  <Card
    data-testid="tracker-card-skeleton"
    className="h-full gap-0 rounded-lg border border-border-light bg-transparent p-0 shadow-none"
  >
    <div className="flex h-full flex-col gap-xl p-section">
      <Skeleton className="size-12 shrink-0 rounded-sm" />
      <div className="flex flex-1 flex-col gap-sm">
        <Skeleton className="h-5 w-2/3" />
        <div className="flex flex-col gap-2">
          <Skeleton className="h-3.5 w-full" />
          <Skeleton className="h-3.5 w-11/12" />
          <Skeleton className="h-3.5 w-3/4" />
        </div>
      </div>
      <div className="flex items-center justify-between border-t border-border-light pt-md">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-4 w-20" />
      </div>
    </div>
  </Card>
);

TrackerCardSkeleton.displayName = 'TrackerCardSkeleton';
